"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _popover = _interopRequireDefault(require("./shared/popover"));

var _contextual_menu = _interopRequireDefault(require("./shared/contextual_menu"));

require("../css/pagination.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var defaultPageLinksToRender = 5;
var paginationDefaultProps = {
  firstPageDisabled: false,
  i18n: {
    changePageSize: 'Change page size',
    currentPage: 'Current page, page %{pageNumber}',
    goto: 'Goto page %{pageNumber}',
    information: '%{start} - %{end} of %{total}',
    next: 'Next',
    paginationNavigation: 'Pagination Navigation',
    previous: 'Previous',
    showing: 'Showing',
    showingPosition: 'before'
  },
  lastPageDisabled: false,
  onChangePageSize: undefined,
  onPaginate: undefined,
  pageSize: 25,
  pageSizeOptions: [25, 50, 100],
  pageLinksToRender: defaultPageLinksToRender,
  pageSizeOptionsAlignment: undefined,
  pageSizeOptionsPlacement: undefined,
  pageSizeOptionsPosition: undefined,
  pageSizeOptionsUseJsPositioning: undefined
};

var Information = function Information(_ref) {
  var coordinates = _ref.coordinates,
      i18n = _ref.i18n,
      onChangePageSize = _ref.onChangePageSize,
      pageSize = _ref.pageSize,
      pageSizeOptions = _ref.pageSizeOptions,
      pageSizeOptionsAlignment = _ref.pageSizeOptionsAlignment,
      pageSizeOptionsPlacement = _ref.pageSizeOptionsPlacement,
      pageSizeOptionsPosition = _ref.pageSizeOptionsPosition,
      pageSizeOptionsUseJsPositioning = _ref.pageSizeOptionsUseJsPositioning;

  var renderLabel = function renderLabel() {
    var start = coordinates.start,
        end = coordinates.end,
        last = coordinates.last;
    var infoMsg = i18n.information ? i18n.information : paginationDefaultProps.i18n.information;
    infoMsg = infoMsg.replace('%{start}', start).replace('%{end}', end).replace('%{total}', last);
    return infoMsg;
  };

  var renderShowingLabel = function renderShowingLabel() {
    return _react.default.createElement("span", {
      className: "vn-pagination__information__showing"
    }, ' ', i18n.showing, ' ');
  };

  var handleClick = function handleClick(event, option) {
    event.preventDefault();

    if (onChangePageSize && option.value !== pageSize) {
      onChangePageSize(option.value);
    }
  };

  var optionsAdapter = function optionsAdapter() {
    return pageSizeOptions.map(function (pageSizeOption) {
      return {
        label: pageSizeOption.toString(),
        value: pageSizeOption
      };
    });
  };

  var renderPopoverContent = function renderPopoverContent() {
    return _react.default.createElement(_contextual_menu.default, {
      options: optionsAdapter(),
      onClick: handleClick,
      value: pageSize
    });
  };

  return _react.default.createElement("div", {
    className: "vn-pagination__information"
  }, i18n.showingPosition === 'before' && renderShowingLabel(), _react.default.createElement(_popover.default, {
    alignment: pageSizeOptionsAlignment,
    content: renderPopoverContent(),
    placement: pageSizeOptionsPlacement,
    position: pageSizeOptionsPosition,
    targetRole: "button",
    useJsPositioning: pageSizeOptionsUseJsPositioning
  }, _react.default.createElement("span", null, renderLabel())), i18n.showingPosition === 'after' && renderShowingLabel());
};

Information.propTypes = {
  coordinates: _propTypes.default.shape({
    start: _propTypes.default.number.isRequired,
    end: _propTypes.default.number.isRequired,
    last: _propTypes.default.number.isRequired
  }).isRequired,
  i18n: _propTypes.default.shape({
    changePageSize: _propTypes.default.string.isRequired,
    information: _propTypes.default.string.isRequired
  }).isRequired,
  onChangePageSize: _propTypes.default.func,
  pageSize: _propTypes.default.number,
  pageSizeOptions: _propTypes.default.arrayOf(_propTypes.default.number),
  pageSizeOptionsAlignment: _propTypes.default.oneOf(_popover.default.alignmentOptions),
  pageSizeOptionsPlacement: _propTypes.default.oneOf(_popover.default.placementOptions),
  pageSizeOptionsPosition: _propTypes.default.oneOf(_popover.default.positionOptions),
  pageSizeOptionsUseJsPositioning: _propTypes.default.bool
};
Information.defaultProps = {
  onChangePageSize: null,
  pageSize: 25,
  pageSizeOptions: [25, 50, 100],
  pageSizeOptionsAlignment: 'left',
  pageSizeOptionsPlacement: 'manual',
  pageSizeOptionsPosition: 'down',
  pageSizeOptionsUseJsPositioning: false
};

var NavigationItem = function NavigationItem(_ref2) {
  var active = _ref2.active,
      disabled = _ref2.disabled,
      handleClick = _ref2.handleClick,
      i18n = _ref2.i18n,
      id = _ref2.id,
      label = _ref2.label,
      page = _ref2.page;
  var isPage = !Number.isNaN(Number(id));
  var tabIndex = label === '...' || disabled ? -1 : 0;
  var itemContentClassNames = (0, _classnames.default)({
    'vn-pagination__navigation-item-content': true,
    'vn-pagination__navigation-item-content--disabled': disabled,
    'vn-pagination__navigation-item-content-page': isPage && !disabled,
    'vn-pagination__navigation-item-content-page--active': isPage && active && !disabled,
    'vn-pagination__navigation-item-content-page--ellipsis': label === '...'
  });

  if (disabled || page === -1 || active) {
    var currentPage = i18n.currentPage ? i18n.currentPage : paginationDefaultProps.i18n.currentPage;
    currentPage = currentPage.replace('%{pageNumber}', page);

    var _ariaLabel = isPage ? currentPage : label;

    return _react.default.createElement("li", {
      className: "vn-pagination__navigation-item"
    }, _react.default.createElement("div", {
      "aria-current": true,
      "aria-label": _ariaLabel,
      className: itemContentClassNames,
      tabIndex: tabIndex
    }, label));
  }

  var gotoPageMsg = i18n.goto ? i18n.goto : paginationDefaultProps.i18n.goto;
  gotoPageMsg = gotoPageMsg.replace('%{pageNumber}', page);
  var ariaLabel = isPage ? gotoPageMsg : "Goto ".concat(label);
  return _react.default.createElement("li", {
    className: "vn-pagination__navigation-item"
  }, _react.default.createElement("a", {
    "aria-current": false,
    "aria-label": ariaLabel,
    href: "#navigation",
    "data-page_number": page,
    onClick: function onClick(event) {
      return handleClick(event, page);
    },
    className: itemContentClassNames
  }, label));
};

NavigationItem.propTypes = {
  active: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  handleClick: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    currentPage: _propTypes.default.string.isRequired,
    goto: _propTypes.default.string.isRequired
  }).isRequired,
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  label: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  page: _propTypes.default.number.isRequired
};
NavigationItem.defaultProps = {
  active: false,
  disabled: false
};

var Navigation = function Navigation(_ref3) {
  var i18n = _ref3.i18n,
      onPaginate = _ref3.onPaginate,
      coordinates = _ref3.coordinates,
      firstPageDisabled = _ref3.firstPageDisabled,
      lastPageDisabled = _ref3.lastPageDisabled;

  var setPreviousAndNextNavs = function setPreviousAndNextNavs(items, current, first, last) {
    items.unshift({
      disabled: current === first,
      key: 'previous',
      label: "".concat(i18n.previous.toUpperCase()),
      page: current - 1
    });
    items.push({
      disabled: current === last,
      key: 'next',
      label: "".concat(i18n.next.toUpperCase()),
      page: current + 1
    });
  };

  var get3dotsNav = function get3dotsNav(key) {
    return {
      key: key,
      label: '...',
      page: -1
    };
  };

  var set3DotsArrayBeginning = function set3DotsArrayBeginning(items, first, current) {
    items.shift();
    items.unshift(get3dotsNav('3dots-beggining'));
    items.unshift({
      active: current === first,
      disabled: firstPageDisabled,
      key: first,
      label: first,
      page: first
    });
  };

  var set3DotsArrayEnding = function set3DotsArrayEnding(items, last, current) {
    items.pop();
    items.push(get3dotsNav('3dots-ending'));
    items.push({
      active: current === last,
      disabled: lastPageDisabled,
      key: last,
      label: last,
      page: last
    });
  };

  var set3DotsAccordingNavsBeingShown = function set3DotsAccordingNavsBeingShown(firstNavIsBeingShown, lastNavIsBeingShown, items, current, first, last) {
    if (!firstNavIsBeingShown) set3DotsArrayBeginning(items, first, current);
    if (!lastNavIsBeingShown) set3DotsArrayEnding(items, last, current);
  };

  var logic3dots = function logic3dots(firstNavIsBeingShown, lastNavIsBeingShown, items, current, first, last) {
    if (items.length >= defaultPageLinksToRender) {
      if (firstNavIsBeingShown !== lastNavIsBeingShown) {
        set3DotsAccordingNavsBeingShown(firstNavIsBeingShown, lastNavIsBeingShown, items, current, first, last);
      } else if (firstNavIsBeingShown === false && lastNavIsBeingShown === false) {
        set3DotsAccordingNavsBeingShown(firstNavIsBeingShown, lastNavIsBeingShown, items, current, first, last);
      }
    }
  };

  var handleClick = function handleClick(event, pageClicked) {
    event.preventDefault();

    if (onPaginate) {
      onPaginate(pageClicked);
    }
  };

  var first = coordinates.first,
      start = coordinates.start,
      current = coordinates.current,
      end = coordinates.end,
      last = coordinates.last;
  var items = [];
  var firstNavIsBeingShown = false;
  var lastNavIsBeingShown = false;

  for (var i = start; i <= end; i += 1) {
    items.push({
      active: current === i,
      key: i,
      label: i,
      page: i
    });
    if (i === first) firstNavIsBeingShown = true;
    if (i === last) lastNavIsBeingShown = true;
  }

  logic3dots(firstNavIsBeingShown, lastNavIsBeingShown, items, current, first, last);
  setPreviousAndNextNavs(items, current, first, last);
  return _react.default.createElement("nav", {
    "aria-label": i18n.paginationNavigation
  }, _react.default.createElement("ul", {
    className: "vn-pagination__navigation"
  }, items.map(function (item) {
    return _react.default.createElement(NavigationItem, {
      active: item.active,
      disabled: item.disabled,
      handleClick: handleClick,
      i18n: i18n,
      id: item.key,
      key: item.key,
      label: item.label,
      page: item.page
    });
  })));
};

Navigation.propTypes = {
  coordinates: _propTypes.default.shape({
    first: _propTypes.default.number.isRequired,
    start: _propTypes.default.number.isRequired,
    current: _propTypes.default.number.isRequired,
    end: _propTypes.default.number.isRequired,
    last: _propTypes.default.number.isRequired
  }).isRequired,
  firstPageDisabled: _propTypes.default.bool.isRequired,
  i18n: _propTypes.default.shape({
    paginationNavigation: _propTypes.default.string.isRequired,
    previous: _propTypes.default.string.isRequired,
    next: _propTypes.default.string.isRequired
  }).isRequired,
  lastPageDisabled: _propTypes.default.bool.isRequired,
  onPaginate: _propTypes.default.func
};
Navigation.defaultProps = {
  onPaginate: undefined
};

var getCoordinates = function getCoordinates(_ref4) {
  var currentPage = _ref4.currentPage,
      pageLinksToRender = _ref4.pageLinksToRender,
      pageSize = _ref4.pageSize,
      totalItems = _ref4.totalItems;
  var firstPage = 1;
  var lastPage = parseInt((totalItems - 1) / pageSize, 10) + 1;
  var middlePage = parseInt(pageLinksToRender / 2, 10);
  var diffLastPage = middlePage - Math.min(middlePage, lastPage - currentPage);
  var diffFirstPage = currentPage - middlePage - diffLastPage;
  var startPage = Math.max(1, diffFirstPage);
  var endPage = Math.min(lastPage, startPage + (pageLinksToRender - 1));
  var startItem = Math.max((currentPage - 1) * pageSize + 1, 0);
  var endItem = Math.min(currentPage * pageSize, totalItems);
  return {
    page: {
      first: firstPage,
      start: startPage,
      current: currentPage,
      end: endPage,
      last: lastPage
    },
    item: {
      start: startItem,
      end: endItem,
      last: totalItems
    }
  };
};

var Pagination = function Pagination(props) {
  return _react.default.createElement("div", {
    className: "vn-pagination"
  }, _react.default.createElement(Information, _extends({
    coordinates: getCoordinates(props).item
  }, props)), _react.default.createElement(Navigation, _extends({
    coordinates: getCoordinates(props).page
  }, props)));
};

Pagination.propTypes = {
  currentPage: _propTypes.default.number.isRequired,
  firstPageDisabled: _propTypes.default.bool,
  i18n: _propTypes.default.shape({
    changePageSize: _propTypes.default.string.isRequired,
    currentPage: _propTypes.default.string.isRequired,
    goto: _propTypes.default.string.isRequired,
    information: _propTypes.default.string.isRequired,
    next: _propTypes.default.string.isRequired,
    paginationNavigation: _propTypes.default.string.isRequired,
    previous: _propTypes.default.string.isRequired,
    showing: _propTypes.default.string.isRequired,
    showingPosition: _propTypes.default.oneOf(['before', 'after']).isRequired
  }),
  lastPageDisabled: _propTypes.default.bool,
  onChangePageSize: _propTypes.default.func,
  onPaginate: _propTypes.default.func,
  pageSize: _propTypes.default.number,
  pageSizeOptions: _propTypes.default.arrayOf(_propTypes.default.number),
  pageLinksToRender: _propTypes.default.number,
  pageSizeOptionsAlignment: _propTypes.default.oneOf(_popover.default.alignmentOptions),
  pageSizeOptionsPlacement: _propTypes.default.oneOf(_popover.default.placementOptions),
  pageSizeOptionsPosition: _propTypes.default.oneOf(_popover.default.positionOptions),
  pageSizeOptionsUseJsPositioning: _propTypes.default.bool,
  totalItems: _propTypes.default.number.isRequired
};
Pagination.defaultProps = paginationDefaultProps;
Pagination.displayName = 'Pagination';
var _default = Pagination;
exports.default = _default;